<template>
  <div>
    <a-modal
      :title="title"
      :visible="dateVisible"
      width="700px"
      @cancel="chose"
      :footer="null"
    >
      <div class="commondity-list" :date="date" :hotelData="hotelData">
        <a-calendar
          :mode="mode"
          @panelChange="onPanelChange"
          @select="onDateSelected"
        >
          <div style="width: 100%;" slot="dateCellRender" slot-scope="value">
            <div
              :class="{backColor:getListData2(value)[0],'backColorM':value.format('YYYY-MM-DD')==startTime||value.format('YYYY-MM-DD')==endTime}">
              <span class="bgText"
                    v-if="getListData(value)[0]">{{ getListData(value)[0] ? '￥' + getListData(value)[0].priceAdvicePrice : '' }}</span>
              <span class="bgText" v-else>&nbsp;</span>
              <span v-if="date.type==2 && value.format('YYYY-MM-DD')==startTime">入住</span>
              <span v-if="date.type==2 && value.format('YYYY-MM-DD')==endTime">离店</span>
            </div>
          </div>
        </a-calendar>
      </div>
    </a-modal>
  </div>
</template>

<script>
import searchForm from '../../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../../utils/mixins/formMixins'
import { claLoad, select, getDateData } from '../chooseDateTime'

export default {
  name: 'ClassChooseDate',
  mixins: [searchForm, formMixin],
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      mode: 'month',
      hotelMonth: [],
      startTime: '',
      endTime: '',
      newArr: [],
      parentDate: {}//传入父组件的date数据
    }
  },
  props: {
    date: {
      type: Object,
      default: null
    },
    dateVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: false
    },
    hotelData: {
      type: Object,
      default: null
    }
  },
  created() {
    // checkInDate:'', //入住时间/出游时间
    //   departureDate:'',// 离店时间 非酒店类型传null ,
    //   money:0,//订单单价
    //   proType:1,//商品类型 1是酒店 否则其他
    //   days:1,//天数
    this.startTime = this.date.checkInDate
    this.endTime = this.date.departureDate
  },
  mounted() {
    setTimeout(() => {
      if (this.proType == 1 && this.date.checkInDate && this.date.departureDate) {
        this.checkStock(this.date.departureDate, this.date.checkInDate, this.date.departureDate)
      }
    }, 2000)
  },
  methods: {
    chose() {
      this.checkStock(this.date.departureDate, this.date.checkInDate, this.date.departureDate)
      this.$emit('childDate', this.parentDate)
    },
    test() {
      this.$emit('childDate', this.parentDate)
    },
    getMonthHotel() {
      let params = {
        goodsId: this.hotelData.ratePlanId,// 售卖商品Id ,
        priceDateMonth: '',//(string, optional): 售卖时间(月份) 格式 YYYY-MM ,
        proCatalogId: this.hotelData.proCatalogId,// 商品种类 ,
        proId: this.hotelData.proId// 售卖商品ID
      }
      this.getHttpServices().getProService().post('resource/pro/get/proPrice', params)
        .then(detail => {
          this.hotelMonth = detail
          if (!this.date.checkInDate && !this.date.departureDate) {
            this.startTime = null
            this.endTime = null
            this.newArr = []
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    dialogDate() {
      this.dateVisible = true
    },
    getListData(value) {
      let listData = []
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.hotelMonth.find((item, index, arr) => item.priceDate === dateStr)
      if (priceItem) {
        listData.push(priceItem)
      }
      return listData
    },
    getListData2(value) {
      let listData = []
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.newArr.find((item, index, arr) => item === dateStr)
      if (priceItem) {
        listData.push(priceItem)
      }
      return listData
    },
    onPanelChange(date, mode) { //切换月
      this.mode = mode
      if (mode === 'month') {
        // this.monthStr = this.getDateHelper().formatDate(date,"YYYY-MM")
        this.getMonthHotel()
      }
    },
    onDateSelected(date) { //选择checkInDate departureDate startTime endTime
      let time = this.getDateHelper().formatDate(date, 'YYYY-MM-DD')
      if (this.hotelData.proCatalogId == 2) {
        var valueDate = new Date(time).getTime()
        var today = Math.min(new Date(this.startTime).getTime(), new Date().getTime())
        var d = Math.round(((valueDate - today) / (86400000)))
        var endd = Math.round(((valueDate - new Date(this.startTime).getTime()) / (86400000))) + 1
        if (d < 0) {
          return
        }
        new Date(time).getTime()

        if (this.startTime && valueDate == new Date(this.startTime).getTime() && this.endTime) {
          this.startTime = time
          this.endTime = null
          //onChange(value, null, null);
          return
        }
        // //开始日期小于开始日期
        if (valueDate < new Date(this.startTime).getTime() && !this.endTime) {
          this.startTime = time
          this.endTime = null
          // onChange(value, valueDate, null);
          return
        }
        //不能大于20天
        if (this.startTime && this.endTime == null && endd > 20) {
          this.$message.error('选择入住和离店间隔大于二十天')
          return
        }
        //不能入离同天
        if (this.startTime && new Date(time).getTime() == new Date(this.startTime).getTime() && !this.endTime) {
          return
        }
        if (this.startTime && this.endTime) {
          this.startTime = time
          this.endTime = null
          //onChange(value, appThis.data.start, null);
          return
        }
        if (this.startTime && !this.endTime) {
          this.endTime = time
          this.checkStock(time, this.startTime, this.endTime)
          return
        }
        if (!this.startTime && !this.endTime) {
          this.startTime = time
          this.endTime = null
          return
        }
      } else if (this.hotelData.proCatalogId == 1 || this.hotelData.proCatalogId == 83) {
        this.parentDate = this.date
        let falg = true
        this.hotelMonth.forEach(v => {
          if (time == v.priceDate && v.priceStock > 0) {
            falg = false
            this.startTime = time
            this.parentDate.checkInDate = time
            this.parentDate.departureDate = ''
            this.parentDate.money = v.priceAdvicePrice
            this.parentDate.weekDay = this.getweekday(time)
            this.parentDate.minStock = v.priceStock
            this.test()
          }
        })
        if (falg) {
          this.$message.error('选择的日期没有库存')
          return
        }
      }
      // if (this.mode === 'year') {
      //   this.mode = 'month'
      //   this.monthStr = this.getDateHelper().formatDate(date,"YYYY-MM")
      //   this.getMonthPriceInfo();
      // } else {
      //   const dateStr = this.getDateHelper().getFormatDate(date)
      //   if (this.isSelected(date)) {
      //     this.selectedDateList = this.selectedDateList.filter((item, index, arr) => dateStr !== item)
      //   } else {
      //     this.selectedDateList.push(dateStr)
      //   }
      // }
    },
    getweekday(date) {
      let weekArray = new Array('日', '一', '二', '三', '四', '五', '六')
      let week = weekArray[new Date(date).getDay()]
      return week
    },
    checkStock(value, start, end) {
      //离店日期日期减一天
      let dateTime = new Date(value).setDate(new Date(value).getDate() - 1)
      //获取酒店所有选取的价格日期
      let daylsit = this.getAll(start, new Date(dateTime).format())
      let allDayList = []
      var dates = this.hotelMonth
      //获取所有有库存的的日期
      dates.map(function(items, i1) {
        if (items.priceStock != '' && items.priceStock > 0) {
          allDayList.push(items.priceDate)
        }
      })
      let dayStr = allDayList.join(',')
      let newArr = []
      daylsit.forEach(function(item) {
        if (dayStr.indexOf(item) != -1) {
          newArr.push(item)
        }
      })
      this.parentDate = this.date
      //选中日期比较
      if (daylsit.length == newArr.length) {
        this.startTime = start
        this.endTime = end
        this.newArr = newArr
        this.parentDate.checkInDate = start
        this.parentDate.departureDate = end
        this.test()
        this.relustArr(newArr)
      } else {
        this.startTime = null
        this.endTime = null
        this.$message.error('选择日期里有房间没有库存！')
        this.newArr = []
        this.getMonthHotel()
        return
      }
    },
    relustArr(newArr) { //算结果和价格
      if (!newArr.length) {
        return
      }
      this.parentDate.days = newArr.length
      let arr = []
      let money = 0
      this.hotelMonth.forEach(v => {
        newArr.forEach(v2 => {
          if (v.priceDate == v2) {
            arr.push(v.priceStock)
            money += Number(v.priceAdvicePrice)
          }
        })
      })
      this.parentDate.minStock = Math.min.apply(null, arr)
      this.parentDate.money = money
      this.getLogUtils().logWithTag('parentDate', this.parentDate)
      //this.getMonthHotel()

    },
    getAll(begin, end) {
      var arr = []
      var ab = begin.split('-')
      var ae = end.split('-')
      var db = new Date()
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
      var de = new Date()
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
      var unixDb = db.getTime()
      var unixDe = de.getTime()
      for (var k = unixDb; k <= unixDe;) {
        arr.push((new Date(parseInt(k))).format())
        k = k + 24 * 60 * 60 * 1000
      }
      return arr
    }


  }
}
</script>
<style lang="less" scoped>
.commondity-list {
  .ant-fullcalendar table {
    height: 100px;
    border: 0;
    margin: 0;
    border-collapse: collapse;
    border-spacing: 0;

    tr {
      td {
        box-sizing: border-box;
        margin: 0px;
        padding: 0;
        border: 1px #d1d1d1 solid;
      }
    }
  }

  .backColor {
    position: absolute;
    background-color: #ffebcf;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    span {
      text-align: center;
      display: block;
    }
  }

  .backColorM {
    background-color: #eb9b2b;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    span {
      color: #fff;
      text-align: center;
      display: block;
    }
  }

  .bgText {
    display: block;
    margin-top: 40px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 100px;
    background-color: #fff;
    margin: 0;
    border-top: none;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date .ant-fullcalendar-value {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 2;
  }
}

.commondity-list-style {
  .ant-fullcalendar-value {
    color: #fff;
  }
}

.ant-modal-body {
  min-height: 400px;
}

</style>
